<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    let domain = 'https://q-api.elmec.com'
    if (window.location.host === 'cia.elmec.com') {
      domain = 'https://api.elmec.com'
    }

    localStorage.setItem('domain', domain)
  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
}

#app {
  font-family: Poppins-ExtraLight;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}
</style>
